export function b64EncodeUnicode(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
        }));
}

export function b64DecodeUnicode(str) {
    if (!str) return '';

    let stringRetorno = '';
    // Going backwards: from bytestream, to percent-encoding, to original string.
    try{
        stringRetorno = decodeURIComponent(atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }catch (_e){
        try {
            stringRetorno = atob(str);
        } catch (e2) {
            console.error('Base64Utils.b64DecodeUnicode: entrada base64 inválida', e2);
            return '';
        }
    }
    return stringRetorno;

}
